// Human labels for internal horizon keys that occasionally leak into AI prose.
export const KEY_LABELS = {
  h_30: "Days 1–30", h_60: "Days 31–60", h_90: "Days 61–90",
  w_12: "Weeks 1–2", w_34: "Weeks 3–4", w_56: "Weeks 5–6",
  q_1: "Quarter 1", q_2: "Quarter 2", q_3: "Quarter 3", q_4: "Quarter 4",
};

// Strip markdown markers (e.g. **bold**) and humanize raw horizon keys so prose reads
// clean — also fixes content generated before the prompts were hardened, no re-gen needed.
export const stripMd = (s) =>
  (s || "")
    .replace(/\*\*(.*?)\*\*/g, "$1")
    .replace(/__(.*?)__/g, "$1")
    .replace(/(?<!\*)\*(?!\*)(.+?)\*(?!\*)/g, "$1")
    .replace(/`([^`]*)`/g, "$1")
    .replace(/^\s{0,3}#{1,6}\s+/gm, "")
    .replace(/^\s{0,3}[-*+]\s+/gm, "")
    .replace(/\b([hwq]_\d{1,2})\b/g, (m) => KEY_LABELS[m] || m);
